import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', index, canvasWidth, istemplate }) {
  var finalx = sprite.x;
  var finaly = sprite.y;
  sprite.x = -(canvasWidth - sprite.x);
  sprite.y = sprite.y + 300;
  let delay = 0;
  if (istemplate && index) {
    delay = index * (duration * speed);
  }
  var animation = gsap.to(sprite, {
    x: finalx,
    y: finaly,
    duration: duration * speed,
    ease: 'elastic.out(0.6, 0.3)',
    delay: delay,
    paused: true,
  });
  return animation;
}
export default { Animate };
